
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve2254R: IProductData = {
  id: "neve-2254r",
  name: "Neve 2254/R Mono Limiter Compressor",
  description: "Designed in 1969, the original Neve® 2254 mono Limiter/Compressor unit quickly became a legend. Forty years on, the 2254’s successor, the Neve 2254/R mono limiter/compressor represents another milestone.",
  specialOrder: true,
  images: ["/img/neve_2254R_front.jpg", "/img/neve_2254R_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
From the first Diode-bridge compressor, the 2252, through to the early cubic 2254 modules, Neve® compressors have been held in very high regard as often treasured studio essentials. Now, the 2254/R takes this treasured circuit design into the 21st century with a modern 19″ rack format for seamless integration into your studio racks.

The 2254/R Limiter/Compressor uses exclusive Marinair® specification transformers on the input, bridge-driver, sidechain and output stages to produce the sweet sound made famous by the classic 2254.

The 2254 and its predecessors, the 2252 and 2253, were the first dynamics processors to exploit the electrical properties of diodes in their control circuits to produce compression curves. Rupert Neve discovered that distortion properties were significantly reduced by mounting two diodes in a bridge configuration, allowing for ideal compression curves when carefully controlled voltages were applied. As a result, the 2254/R’s diode-bridge circuitry produces a wide range of compression types, ranging from subtle & smooth to aggressive & overdriven.

Though modern in construction, the  2254/R Limiter/Compressor remains true to the original 1969/1970’s models by using class A discrete circuitry throughout its audio signal path, including a discrete transformer-balanced output which evolved from the early Neve® console line output modules.

Multiple 2254/R’s can be linked together via the control voltage link. When units are linked together, they all share a common sidechain to control their gain reduction; whichever unit receives the loudest signal at any given moment becomes the threshold trigger for the group.

The independent compressor and limiter sidechains function as closed loops in isolation from each other. This provides the ultimate dynamic control of transients and giving you the ability to use the 2254/R as a creative tool in the studio.

The 2254/R includes sweepable fast attack control for the limiter, an enhancement on the original. Ranging from 2ms to 100us, this feature allows you to dial in precise limit attack times for your music.

The 2254/R’s moving coil meter can be applied to various points in the signal chain, including the input & output gain stages and gain reduction stages. This system is complemented with a dual colour LED meter to indicate signal at -10dBu and clipping at +25dBu.

The 2254/R’s Limiter & Compressor circuits feature several recovery options, including an auto-recovery setting.  In the AUTO position, both the attack and recovery times are composite and self-adjusting. Speeds are rapid for isolated peaks while remaining slow for persistently high levels, so the impression of a standard dynamic range is preserved as the programme rides on a slowly moving ‘gain platform’.

Every setting on the 2254/R can be recalled in a matter of seconds using the Neve® Recall Software application, simply connect the 2254/R via USB to your DAW computer to access the Neve Recall Software program.
`
    }, {
      label: "Specifications",
      markdown: `
• Classic mono limiter/compressor made to the exacting late-1960s design
• Hand-made in Burnley, England using original Neve specification transformers
• Original Neve 2254 discrete, Class A circuit design
• Transformer-coupled circuits used in Input, Bridge-driver, Sidechain and Output stages
• Manual Fast Attack Time adjustment and transparent level control
• Independent Limiter In/Out and Compressor In/Out selection
• Total bypass switch
• Multiple units can be linked together to provide multi-unit side-chain control from a single unit
• Compatible with Neve Total RecallTM software, simply connect the 2254/R using USB to a host PC or Mac running Neve Recall software
• Hand-crafted and hand-wired by Neve in Burnley, UK
`
}, {
  label: "Audio Performance",
  markdown: `
• Input Impedance: 10k ohm, bridging, balanced, earth free
• Output Impedance: 80 ohms, balanced & earth free
• Maximum Output: +26dBu into 600 ohms
• Gain: 0dB, preset adjustment
• Frequency Response: Flat, within 1dB from 20 Hz to 20 kHz
• Noise: -72.5dBu in the band 20 Hz to 20 kHz
• Distortion (Typically measured at+8dBu, 800mS Recovery): 0dBu: 0.03% / +15dBu: 0.2%
`
  }, {
    label: "Limiter Specification",
    markdown: `
• Ratio: >100:1
• Level: Adjustable from +4 dBu to +20dBu in 1dB steps
• Attack Time: 5 mS (slow) or selectable between 100 µS to 2 mS (Fast)
• Recovery Time: Selectable between 100 mS / 200 mS / 800 mS / Auto
`
  }, {
    label: "Compressor Specification",
    markdown: `
• Ratio: Selectable between 1.5:1 / 2:1 / 3:1 / 4:1 / 6:1
• Threshold: Adjustable from -20dBu to +10 dBu in 2 dB steps
• Attack Time: 5 mS
• Recovery Time: Selectable between 400 mS / 800 mS / 1500 mS / Auto
• Gain Make Up: Adjustable Gain make-up available from 0 dB to +20 dB

`
  }, {
    label: "Dimensions",
    markdown: `
• Width: 482mm (19 inches)
• Height: 45mm (1.75 inches) (1U)
• Depth: 254mm (10 inches)
• Weight: 5kg (11 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/limiter-compressors/2254-r-mono-limiter-compressor" target="_blank">https://www.ams-neve.com/outboard/limiter-compressors/2254-r-mono-limiter-compressor</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.LIMITER, HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.MASTERING, HASHTAGS.ONE_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}